import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';


import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';



const propositionAchatLabel = "Proposer l'achat d'un article neuf ";
const propositionsAchat = [
    "Le client a accepté",
    "Le client ne souhaite pas un produit neuf"
];


const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1)
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});




class PropositionAchat extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            [ReclamationQualificationDetailCodes.PropositionAchat]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.PropositionAchat,
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    getQualificationData(newState) {

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        if (
            newState[ReclamationQualificationDetailCodes.PropositionAchat] === ''
        ) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.PropositionAchat,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: propositionAchatLabel,
            valeurString: propositionsAchat[newState[ReclamationQualificationDetailCodes.PropositionAchat]],
            valeurInteger: newState[ReclamationQualificationDetailCodes.PropositionAchat],

        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.PropositionAchat);


        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {
        const { classes } = this.props;


        return (
            <div className={classes.row}>
                <FormControl required className={classes.formControl}>
                    <FormLabel>{propositionAchatLabel}</FormLabel>
                    <RadioGroup name={ReclamationQualificationDetailCodes.PropositionAchat} className={classes.group} value={this.state[ReclamationQualificationDetailCodes.PropositionAchat]} onChange={this.handleChange}>
                        {propositionsAchat.map((reponse, index) => (
                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        );
    }

}


PropositionAchat.propTypes = {
    name: PropTypes.string.isRequired
};

//PropositionAchat.defaultProps = {
//};

export default withStyles(styles)(PropositionAchat);